.innerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.outerRow {
  composes: innerRow;
  padding-bottom: var(--via-space-200);
}
